import { getPath } from "src/basepath";

export const newTab = (url: string) => {
  // biome-ignore lint: ok
  window.open(getPath(url), "_blank");
};
